/* @ngInject */
export default function BuilderSidebarDirective($location, $window, $translate, ParametricBuilderService, CacheService,
                                                NotifyingService, NavigationService,
                                                SleuthService, SpinnerLoadingService, ContainerInfoApiService) {
    return {
        restrict: 'A',
        scope: {
            definition: '=',
            filters: '=',
            alwaysShowParameters: '=showParameters',
            externalSeriesId: '=',
            onChange: '&',
            onInit: '&'
        },
        templateUrl: require('./builder.directive.html'),
        link: function (scope) {
            if (scope.onInit()) {
                scope.onInit()(scope);
            }

            scope.handleRefresh = function () {
                var definition = ParametricBuilderService.getCurrentRootDefinition();
                if (definition !== undefined) {
                    definition.showParameters = true;
                }
            };

            if (CacheService.getAllDefinitions()) {
                scope.definitions = CacheService.getAllDefinitions();
            }

            NotifyingService.subscribeToModelServiceInit(scope, scope.handleRefresh);
            NotifyingService.subscribeToSleuthChanges(scope, scope.handleRefresh);
            NavigationService.openMenu();

            /**
             * Handle the multi-select box click
             *
             * @param dp - Definition Parameter, comes from Builder Controller when we get Definition Parameter by Definition
             * and Display Area.
             * @param dpv - Definition Parameter Value, which comes from iterating the Definition Parameter's values in
             * the directive template.
             * @return {void}
             */
            scope.handleSelectClicked = function (dpv, dp) {
                if (dp.query === undefined) {
                    dp.query = {
                        /*
                        NOTE: Do NOT check on selectedFormattedValue downstream, for the multiple select box, because
                        it's unreliable. The user could type "10" then select "100 V" and this value will be "10".
                         */
                        parameterDisplayName: ContainerInfoApiService.getDisplayName(dpv.parameterDisplayNames,
                            CacheService.getConfigurationInfo().language),
                        parameterDisplayNames: dpv.parameterDisplayNames,
                        parameterId: dpv.parameterId,
                        parameterName: dpv.parameterName
                    };
                }

                // Needs to come before the hasValueAlready check
                if (dp.query.selectedFormattedValues === undefined) {
                    dp.query.selectedFormattedValues = [];
                }


                // Need to accommodate the case where user is trying to add the same value
                if (scope.hasValueAlready(dpv.formattedValue, dp.query.selectedFormattedValues)) {
                    var message = $translate.instant('message__alert__alreadySelected', {value: dpv.formattedValue}).valueOf();
                    alert(message);
                }
                dp.query.selectedFormattedValues.push(dpv);


                //dpv.query.selectedFormattedValue = ''; // This will be done by the Builder Service prior to hitting sleuth
                dp.showAllList = false;
                dp.showFilteredList = false;
                scope.filterChildren();
            };


            /**
             * Check if the value already exists or not
             *
             * @param value
             * @param values
             * @return {boolean}
             */
            scope.hasValueAlready = function (value, values) {
                if (values.length > 0) {
                    var valueCount = values.length;
                    for (var i = 0; i < valueCount; i++) {
                        if (values[i].formattedValue === value) {

                            return true;
                        }
                    }
                    return false;
                }
                return false;
            };

            scope.filterChildren = function () {
                SpinnerLoadingService.showLoading();
                var query = ParametricBuilderService.buildQueryData(scope.filters, scope.externalSeriesId);

                if (query.values.length == 0) {
                    SleuthService.removeSleuthData();
                    SpinnerLoadingService.hideLoading();
                } else {
                    SleuthService.executeParameterValueSearchByQuery(query, function (response) {
                        if (scope.filters.length > 0 && $location.path() !== '/browsing') {
                            NavigationService.openMenu();
                            if (scope.onChange()) {
                                scope.onChange()(response);
                            }
                        }

                        // this makes the experience a little better to scroll to the top.
                        scope.emulatePageRefresh();

                        SpinnerLoadingService.hideLoading();
                    });
                }
            };

            scope.emulatePageRefresh = function () {
                $window.scrollTo(0, 0);
            };

            scope.updateCssClasses = function (definition, siblings) {
                siblings.forEach(function (sibling) {
                    if (definition.id !== sibling.id) {
                        sibling.setActiveClass = false;
                        sibling.showParameters = false;
                    }
                });

                definition.setActiveClass = true;
                definition.showParameters = true;
            };

            scope.hideAllOtherMenus = function (definition, siblings) {
                scope.updateCssClasses(definition, siblings);

                ParametricBuilderService.updateCache(definition, function (menu) {
                    scope.filters = menu;
                });
                $location.path('/browsing').search('id', CacheService.getDefinition().id);
                NotifyingService.notifyRootDefinitionChangeEvent();
            };

            scope.turnOnFilter = function (filters, filter) {
                filter.showFilteredList = filter.query.selectedFormattedValue.length !== 0;
                scope.populateLists(filters, filter, filter.event);
            };

            scope.storeEvent = function (filter, $event) {
                filter.event = $event;
            };

            scope.populateLists = function (filters, filter, $event) {
                ParametricBuilderService.hideAllDropDowns(filters, filter);
                if (filter.cachedParameterValues === undefined) {
                    filter.cachedParameterValues = filter.parameterValues;
                }
                ParametricBuilderService.createClickEvents(filter, scope, $event.target.parentElement.parentElement);
                ParametricBuilderService.addClickEvents(filter, $event.target.parentElement.parentElement);
            };

            scope.showAllLists = function (filters, filter, $event) {

                if (filter.showAllList) {
                    filter.showAllList = false;
                    filter.showFilteredList = false;
                } else {
                    filter.showAllList = true;
                }

                if (filter.showFilteredList) {
                    filter.showAllList = false;
                    filter.showFilteredList = false;
                }
                scope.populateLists(filters, filter, $event);
            };

            scope.displayParameterName = function (filter) {
                if (CacheService.getConfigurationInfo() !== undefined) {
                    return ContainerInfoApiService.getDisplayName(filter, CacheService.getConfigurationInfo().language);
                } else {
                    return ContainerInfoApiService.getDisplayName(filter, 'ENGLISH');
                }
            };

            scope.displayName = function (filter) {
                if (CacheService.getConfigurationInfo() !== undefined) {
                    return ContainerInfoApiService.getDisplayName(filter, CacheService.getConfigurationInfo().language);
                } else {
                    return ContainerInfoApiService.getDisplayName(filter, 'ENGLISH');
                }
            };

            scope.displayValue = function (value) {
                if (value.formattedValue !== undefined && value.formattedValue !== null) {
                    return value.formattedValue;
                }

                var translatedValue = null;
                if (CacheService.getConfigurationInfo() !== undefined) {
                    translatedValue = ContainerInfoApiService.getDisplayName(value, CacheService.getConfigurationInfo().language);
                }
                if (translatedValue == null) {
                    translatedValue = value.value;
                }
                return translatedValue;
            };

            scope.removeUnknownValue = function (filter) {
                filter.unknownValue = undefined;
                scope.filterChildren();
            };


            // Not use for multi select
            // scope.setUnclick = function(parameterValues, selectedValue) {
            //     angular.forEach(parameterValues, function(value) {
            //         if(selectedValue.id === value.id) {
            //             return;
            //         }
            //         // if(value.clicked !== undefined) {
            //         //     value.clicked = false;
            //         // }
            //     });
            // };

            NotifyingService.subscribeToSleuthChanges(scope, scope.removeSelectedParmValues);

            scope.removeSelectedParmValues = function () {
                if (SleuthService.getSleuthData() === undefined) {
                    angular.forEach(scope.filters, function (filter) {
                        if (filter.query) {
                            filter.query.clicked = false;
                            filter.query.selectedFormattedValues = [];
                            filter.query.selectedFormattedValue = undefined;
                            filter.query = undefined;
                        }
                    });
                }
            };

            scope.handleClick = function (definitionParameter, value) {
                SleuthService.createDefinitionParameterQuery(definitionParameter, value);
                var valueIndex = definitionParameter.query.selectedFormattedValues.indexOf(value);
                if (valueIndex == -1) {
                    definitionParameter.query.selectedFormattedValues.push(value);
                } else {
                    definitionParameter.query.selectedFormattedValues.splice(valueIndex, 1);
                }
                NotifyingService.notifyOfBuilderFilterAction();
                // if(definitionParameter.query.)
                // if(value.clicked !== undefined && value.clicked) {
                //     value.clicked = false;
                //     definitionParameter.query = undefined;
                // } else {
                //     // scope.setClicked(definitionParameter, value);
                //     NotifyingService.notifyOfBuilderFilterAction();
                // }
            };

            // scope.setClicked = function(definitionParameter, value) {
            //     definitionParameter.query = value;
            //     definitionParameter.query.selectedFormattedValue = definitionParameter.query.formattedValue;
            //     definitionParameter.query.clicked = true;
            // };

            /**
             * Reset the user input
             *
             * @param sfv - The Selected Formatted Value, that comes from iterating the Selected Formatted Values array
             * in the directive template.
             * @param sfvs - The Selected Formatted Values array, sent in from the template.
             * @return {void}
             */
            scope.resetInput = function (sfv, sfvs, $event) {
                for (var i = 0; i < sfvs.length; i++) {
                    if (sfv.id === sfvs[i].id) {
                        sfvs.splice(i, 1);
                    }
                }
                // sfv.query.selectedFormattedValue = '';
                // //sfv.query.selectedFormattedValues = [];
                //sfv.query = undefined;

                $($event.target).parents('section').children('ul').find('li.currently-selected').each(function () {
                    if (this.innerHTML == sfv.formattedValue) {
                        this.classList.remove('currently-selected');
                    }
                });
                scope.filterChildren();
            };

            /**
             * Handle the displaying and hiding of the placeholder attribute depending on if there are selected formatted values.
             *
             * @param sfvs - Selected Formatted Values which comes from the directive template
             * @param pdn - Parameter Display Name which comes from the directive template
             * @return {string}
             */
            scope.handlePlaceholderDisplay = function (sfvs, pdn) {
                if (sfvs === undefined || sfvs.length < 1) {

                    // return "Filter " + pdn;
                    return $translate.instant('label__placeholder_filter', {someParameter: pdn}).valueOf();
                } else {
                    return '';
                }
            };

            /**
             * Remove the Chip when the user hits backspace and there's no content in model bindings
             *
             * @param event - key down event
             * @param sfvs - The Query object which comes from the directive template
             * @param sfv - Selected Formatted Value which comes from the directive template's model bindings
             * @return {void}
             */
            scope.removeChipOnBackspace = function (event, sfvs, sfv) {
                var lastChipKey;
                if (sfvs !== undefined && sfvs.length > 0) {
                    if (event.keyCode === 8) { // delete key
                        lastChipKey = sfvs.length - 1;
                        if (sfv === '' && sfvs[lastChipKey].hasBeenSelectedForDeletion === undefined) {
                            sfvs[lastChipKey].hasBeenSelectedForDeletion = true;
                        } else if (sfvs[lastChipKey].hasBeenSelectedForDeletion !== undefined && sfvs[lastChipKey].hasBeenSelectedForDeletion) {
                            sfvs.splice(lastChipKey, 1);
                            scope.filterChildren();
                        }
                        // unimplemented functionality, but useful for UX, wait for a story.
                    } else if (event.keyCode === 37) { // left arrow, select for deletion
                        // move through the list to select a specific item for deletion
                    } else if (event.keyCode === 39) { // right arrow
                        // unselect for deletion
                    } else {
                        lastChipKey = sfvs.length - 1;
                        if (sfvs[lastChipKey].hasBeenSelectedForDeletion !== undefined && sfvs[lastChipKey].hasBeenSelectedForDeletion) {
                            // unselect for deletion
                        }
                    }
                }
            };

            scope.handleElementSize = function (event, items) {
                const initialWidth = 25;
                const newValueLength = event.currentTarget.value.length;
                let newWidth;
                let width;
                if (items !== undefined && items.length > 0 && newValueLength > 0) {

                    if (event.currentTarget.style.width !== '') {
                        width = parseInt(event.currentTarget.style.width);
                    } else {
                        width = initialWidth;
                    }

                    newWidth = parseInt(width + 10);

                    event.currentTarget.style.width = newWidth + 'px';
                    console.log(event.currentTarget.style.width);
                }
            };

            scope.focusOnInput = function (filter) {
                'use strict';
                filter.hasFocus = true;
            };

            scope.unFocusOnInput = function (filter) {
                'use strict';
                filter.hasFocus = false;
            };
        }
    };
}
